import { render, staticRenderFns } from "./EmailDetailInfoDialog.vue?vue&type=template&id=70f6efe2&"
import script from "./EmailDetailInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./EmailDetailInfoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EmailDetailInfoDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports